import { requireNativeModule } from "expo-modules-core";

import { COMPONENT_NAME } from "./constants";

export const NativeModule = requireNativeModule(COMPONENT_NAME);
